// extracted by mini-css-extract-plugin
export var endpointPill = "Endpoints-module--endpointPill--f6c32";
export var link = "Endpoints-module--link--ce300";